import {hideLoadingFunction, showDialogLoading, showLoading} from 'Core/helpers/loading';
import {ioJsonAction, ioJsonDeleteItemAction} from 'Core/store/actions/io';
import {getArray} from 'Core/helpers/data';

/**
 * Fetch the list of saved eFax numbers (eFax phonebook).
 * 
 * @param {function} [abortCallback=(abortController)=>{}] - Callback function that will receive AbortController as an
 * argument.
 * @param {string} studyId - ID of the study containing the necessary account information.
 * @return {function(*): Promise<string[]>} Returns a promise that resolves to an array of strings representing the eFax 
 * numbers in international format (with '+' prefix).
 */
export const fetchEFaxNumbersAction = (abortCallback, studyId) => dispatch => {
	return ioJsonAction(
		abortCallback,
		'defaultAuthorizedApi',
		'study/fetch-efax-numbers',
		{studyId},
	)(dispatch)
		.then(res => getArray(res, 'data'));
};

/**
 * Delete an eFax number from the list of saved eFax numbers (eFax phonebook).
 * 
 * @param {function} [abortCallback=(abortController)=>{}] - Callback function that will receive AbortController as an
 * argument.
 * @param {string} studyId - ID of the study containing the necessary account information.
 * @param {string} eFaxNumber - Phone number to delete from the list of already saved eFax numbers in the international 
 * format (with '+' prefix).
 * @return {function(*): Promise<IoJsonResponseObject|undefined>}
 */
export const deleteEFaxNumberAction = (abortCallback, studyId, eFaxNumber) => dispatch => {
	const loading = showLoading('#e-fax-confirm-phone-delete-dialog .dialog-content-component > .buttons');
	return ioJsonDeleteItemAction(
		abortCallback,
		'defaultAuthorizedApi',
		'study/delete-efax-number',
		{studyId, eFaxNumber},
		hideLoadingFunction(loading),
	)(dispatch);
};

/**
 * Send the report to an eFax number.
 *
 * @param {function} [abortCallback=(abortController)=>{}] - Callback function that will receive AbortController as an
 * argument.
 * @param {string} studyId - ID of the study containing the necessary account information.
 * @param {string} eFaxNumber - Phone number to send the eFax report to in the international format (with '+' prefix).
 * @param {string} reportName - Name of the report to send via eFax to a specified phone number.
 * @return {function(*): Promise<IoJsonResponseObject|undefined>}
 */
export const sendEFaxReportAction = (abortCallback, studyId, eFaxNumber, reportName) => dispatch => {
	const loading = showDialogLoading('e-fax-dialog');
	return ioJsonAction(
		abortCallback,
		'defaultAuthorizedApi',
		'study/send-report-via-efax',
		{studyId, eFaxNumber, reportName},
		hideLoadingFunction(loading),
	)(dispatch);
};